import {z} from 'zod';

export const betterAuthErrorSchema = z.object({
  message: z.string().optional(),
  status: z.number().optional(),
  statusText: z.string().optional(),
  code: z.string().optional(),
});

export const betterAuthUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  image: z.string().nullish(),
});

export const betterAuthSessionResponseSchema = z.object({
  user: betterAuthUserSchema,
});

export type BetterAuthError = z.output<typeof betterAuthErrorSchema>;
export type BetterAuthUser = z.output<typeof betterAuthUserSchema>;
